import todosApi from '../../api/todos'
// initial state
const state = {
  overdueCount: 0,
  items: [],
  listID: null,
};

const getters = {
  //unreadRequests: state => {
    //return state.requestMessages.slice().filter(r => {
      //if (!r.read) {
        //return r;
      //}
    //}).length;
  //},
  overdueCount: state => {
    // TODO
    return 0
  }
};

const actions = {
  createTodo( { dispatch, commit }, todoParams) {
    return new Promise((resolve, reject) => {
      todosApi.create(todoParams)
        .then((res) => {
          const todo = res.data
          commit('addTodo', todo)
          dispatch('getOverdueCount')
          resolve(todo)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  getMine({ commit } ){
    return new Promise((resolve, reject) => {
      todosApi.getMine()
        .then((res) => {
          const todos = res.data.todos
          const listID = res.data.list_id
          commit('setTodos', todos)
          commit('setListID', listID)
          resolve(todos)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  getManaged({ commit }, employeeID){
    return new Promise((resolve, reject) => {
      todosApi.getManaged(employeeID)
        .then((res) => {
          const todos = res.data.todos
          commit('setTodos', todos)
          resolve(todos)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  getOverdueCount({ commit }, userID) {
    return new Promise((resolve, reject) => {
      todosApi.getOverdueCount(userID)
        .then((res) => {
          const count = res.data.overdue
          commit('setOverdueCount', count)
          resolve(count)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  markDone({ commit, dispatch }, todoID) {
    return new Promise((resolve, reject) => {
        todosApi.update(todoID, {
        done: true
      })
        .then((res) => {
          const todo = res.data
          commit('setTodo', todo)
          dispatch('getOverdueCount')
          resolve(todo)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  markUndone({ commit, dispatch }, todoID) {
    return new Promise((resolve, reject) => {
      todosApi.update(todoID, {
        done: false
      })
        .then((res) => {
          const todo = res.data
          commit('setTodo', todo)
          dispatch('getOverdueCount')
          resolve(todo)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  sendReminder({ commit }, todoID) {
    todosApi.remind(todoID)
      .then((res) => {
        resolve(ees)
      })
      .catch((e) => {
        reject(e)
      })
  },

  //markRead({commit}, messageId) {
    //return new Promise((resolve, reject) => {
      //messagesApi.markRead(
        //messageId,
        //message => {
          //commit('updateMessage', message);
          //resolve();
        //},
        //error => {
          //console.log('Could not mark this message as read');
          //reject();
        //},
      //);
    //});
  //},

};

const mutations = {
  setOverdueCount(state, count) {
    state.overdueCount = count
  },
  setTodos(state, items) {
    state.items = items;
  },
  setListID(state, id) {
    state.listID = id;
  },
  addTodo(state, newTodo) {
    state.items.push(newTodo)
  },
  setTodo(state, item) {
    state.items = [
      ...state.items.filter(t => t.id !== item.id),
      item,
    ]
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
